import React from 'react'
import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core'
import CancelButton from 'app/components/buttons/CancelButton'
import DeleteButton from 'app/components/buttons/DeleteButton'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import clsx from 'clsx'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'

export default (props) => {
  const {
    state,
    classes,
    toggleDialogs,
    DETACH_SUBSCRIBERS_DIALOG,
    handleDetachSubscribers,
  } = props
  const mobileClasses = useMobileStyle()

  return (
    <ResponsiveDialog
      isFullScreen={false}
      open={state[DETACH_SUBSCRIBERS_DIALOG]}
      className={clsx(classes.groupDialog, mobileClasses.lessPaddingMobile)}
    >
      <DialogTitle id="alert-dialog-title" className={classes.groupDeleteTitle}>
        {state.detachSubscribersInfo.deleteDialogTitle}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {state.detachSubscribersInfo.deleteDialogDesc}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CancelButton
          onClick={() => {
            toggleDialogs(DETACH_SUBSCRIBERS_DIALOG, false)
          }}
          className={mobileClasses.modalBtn}
        />
        <DeleteButton
          className={mobileClasses.modalBtn}
          onClick={handleDetachSubscribers}
        />
      </DialogActions>
    </ResponsiveDialog>
  )
}
